$(document).ready(function() {
    function t(t) {
        var o = $(t).offset().top - 85;
        $("html,body").animate({
            scrollTop: o
        }, 500)
    }
  
  
  //Free Items CODE start
  var total_free_qty = 0, free_items_added = 0, latest_free_id = '', latest_qty;

  $(document).on('cart.requestComplete', function(event, cart) {
    console.log(cart)
    total_free_qty = 0;
    free_items_added = 0;
    latest_free_id = '';
    latest_qty = 0;
    cart.items.forEach(x => {
      if(x.handle == "busta" || x.handle == "classic" ){
        if(x.variant_title.includes('590')){
          total_free_qty = total_free_qty+x.quantity;
        }

      }
      if(x.price == 0){
        free_items_added = free_items_added+x.quantity;
        console.log(x.variant_title)
        latest_free_id = x.variant_id;
        latest_qty = x.quantity
      }
    })

    var remain_items = total_free_qty-free_items_added;

    if(remain_items > 0){
      setTimeout(()=>{
      // $('.modal-1').addClass('is-visible');
      },1400)
      $('#max-qty-1').val(remain_items)
      $('.modal-content-1 .btn-addtocart').prop('disabled', false)
      $('.warning-items').html('(You can add maximum of '+remain_items+' items for free.)')
    }else{
      $('.modal-1').removeClass('is-visible')
      $('.modal-content-1 .btn-addtocart').prop('disabled', true)

    }

    if(remain_items < 0){
      CartJS.updateItemById(latest_free_id, parseInt(latest_qty)-1)
    }
  })
  
  //Free Items CODE End
  
//      $(document).on('cart.requestComplete', function(event, cart) {
//        var quantity330 = 0;
//        var quantity500 = 0;
//        var found330 = false;
//        var found500 = false;
//        var changeQty330 = false;
//        var changeQty500 = false;
//        var exQuant330 = 0;
//        var exQuant500 = 0;
//        cart.items.forEach(function(x){
//          //Check quantity for 330ml
//          if(x.id == 40965407047873 || x.id == 40970409214145 ){
//            quantity330 = quantity330+x.quantity;
//          }else if(x.id == 38146460942529 || x.id == 40970411573441){
//            quantity500 = quantity500+x.quantity;
//          }else if(x.id == 41188683874497){
//            found500 = true;
//            exQuant500 = x.quantity;
//            if(x.quantity != quantity500){
//              changeQty500 = true;
//            }
//          }else if(x.id == 41188689182913){
//            found330 = true;
//            exQuant330 = x.quantity;
//            if(x.quantity != quantity330){
//              changeQty330 = true;
//            }
//          }

//      }) 
       
//        setTimeout(()=>{
//                   if(!found330){
//          CartJS.addItem(41188689182913, quantity330);
//          //            addItem(41188689182913, quantity330)
//          //            console.log('adding item')
//        }else if(exQuant330 != quantity330 ){
//          CartJS.updateItemById(41188689182913, quantity330)
//          //            console.log('Updating item')
//          changeQty330 = false;
//        }

//        if(!found500){
//          CartJS.addItem(41188683874497, quantity500);
//          //            addItem(41188683874497, quantity500)
//        }else if(exQuant500 != quantity500 ){
// //          console.log(quantity500)
//          CartJS.updateItemById(41188683874497, quantity500)
//          changeQty500 = false;
//        }

//      },30)
//     });

function addItem(id, qty){
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: qty,
      id: id
    },
    dataType: 'json', 
    success: function (data) {
		console.log('Item Added')
    } 
  });
}

    function o() {
        $.each($(".animate"), function(t, o) {
            $(this).shouldAnimate() && ($(this).removeClass("animate"), $(this).addClass("animated"), $(this).addClass($(this).data("animation")))
        })
    }
    $("a[href^=#]").not(".ignore").on("click", function(o) {
        o.preventDefault(), t($(this).attr("href"))
    }), $(document).on("ready", function() {
        $("img:not(.owl-lazy)").Lazy()
    }), $(".share-link").on("click", function(t) {
        t.preventDefault();
        var o = $(this).attr("href");
        window.open(o, "Share", "width=600,height=400")
    }), $(window).on("scroll", function() {
        $(this).scrollTop() > 200 ? $(".to-top").addClass("visible") : $(".to-top").removeClass("visible")
    }), $(document).on("click", ".to-top", function(t) {
        t.preventDefault(), $("body, html").animate({
            scrollTop: 0
        }, 1e3)
    }), $.fn.shouldAnimate = function() {
        var t = $(window),
            o = {
                top: t.scrollTop() - 50,
                left: t.scrollLeft()
            };
        o.right = o.left + t.width(), o.bottom = o.top + t.height();
        var e = this.offset();
        return e.right = e.left + this.outerWidth(), e.bottom = e.top + this.outerHeight(), !(o.right < e.left || o.left > e.right || o.bottom < e.top)
    }, o(), $(document).ready(o), $(document).on("scroll", function() {
        o()
    });
    var e = $(".store-notice").outerHeight() || 0;

    function i() {
        $(this).scrollTop() >= e ? $("body").addClass("fixed-navbar") : $("body").removeClass("fixed-navbar")
    }
    if ($(window).on("scroll", function() {
            i()
        }), $(window).on("resize", function() {
            e = $(".store-notice").outerHeight() || 0
        }), i(), $(document).on("click", ".menu-toggle", function(t) {
            t.preventDefault(), $("body").toggleClass("menu-open")
        }), new Rellax(".rellax", {
            center: !0
        }), $(".add-to-cart-bar-position").length) {
        function a() {
            let t = $(".add-to-cart-bar-position").offset().top - $(".header").height();
            $(this).scrollTop() > t ? $("body").addClass("show-atcb") : $("body").removeClass("show-atcb")
        }
        $(window).on("scroll", function() {
            a()
        }), a(), $(".add-to-cart-bar").on("click", function(o) {
            o.preventDefault(), t("#product-details")
        })
    }
    $(document).on("click", ".cart-toggle", function(t) {
        t.preventDefault(), $("body").toggleClass("cart-open")
    });
    var n = 1;

    function l(t, o) {
        CartJS.cart.items.forEach(o => {
            o.id != t || (n = 0)
        }), CartJS.cart.items_subtotal_price > 100 * o && 1 == n && (n = 0, CartJS.addItem(t))
    }

    function s() {
        $(window).width() >= 768 ? ($(".products-carousel").removeClass("row-flex").addClass("owl-carousel"), $(".products-carousel").owlCarousel({
            lazyLoad: !1,
            loop: !1,
            nav: !0,
            dots: !1,
            autoplay: !1,
            autoplayTimeout: 5e3,
            margin: 10,
            responsive: {
                0: {
                    items: 1
                },
                768: {
                    items: 3
                },
                992: {
                    items: 4
                },
                1440: {
                    items: 5
                }
            },
            navText: ['<div><i class="glyphicon glyphicon-menu-left"></i></div>', '<div><i class="glyphicon glyphicon-menu-right"></i></div>']
        })) : ($(".products-carousel").removeClass("owl-carousel").addClass("row-flex"), $(".products-carousel").owlCarousel("destroy")), $(".nav-categories ul").length && $(".nav-categories ul").hasScrollBar() ? $(".nav-categories button").css("display", "block") : $(".nav-categories button").css("display", "none")
    }

    function r(t) {
        CartJS.cart.items_subtotal_price > 0 * t ? ($(".confirm-button").removeClass("disabled"), $(".min-text").hide()) : ($(".confirm-button").addClass("disabled"), $(".min-text").show())
    }
    setTimeout(() => {
        //l(34773717713058, 300), 
           r(49)
    }, 420), $(document).on("cart.requestComplete", function(t, o) {
        $(".cart-counter").html(o.item_count), $("body").not(".template-cart").addClass("cart-open"), setTimeout(() => {
            n = 1 
                                                                                                                 //l(34773717713058, 300)
        }, 550)
          r(49)
    }), $(".home-hero-carousel").owlCarousel({
        items: 1,
        loop: !0,
        nav: !1,
        dots: !0,
        autoplay: !0,
        margin: 0
    }), $.fn.hasScrollBar = function() {
        return this.get(0).scrollWidth > this.width()
    }, $(".btn-scroll-left").click(function() {
        $(".nav-categories ul").animate({
            scrollLeft: "-=45px"
        })
    }), $(".btn-scroll-right").click(function() {
        $(".nav-categories ul").animate({
            scrollLeft: "+=45px"
        })
    }), $(".products-cart-carousel").owlCarousel({
        lazyLoad: !1,
        loop: !1,
        nav: !0,
        dots: !1,
        autoplay: !1,
        autoplayTimeout: 5e3,
        margin: 10,
        items: 2,
        navText: ['<div><i class="glyphicon glyphicon-menu-left"></i></div>', '<div><i class="glyphicon glyphicon-menu-right"></i></div>']
    }), $(".cart-drawer-products form button[type=submit]").on("click", function(t) {
        $(".cart-drawer-inner").animate({
            scrollTop: 0
        })
    }), s(), $(window).on("resize", s), $(".collection-categories .nav li.active").length && $(".collection-categories .nav").scrollLeft($(".collection-categories .nav li.active").offset().left - 50), $(".testimonials-carousel").owlCarousel({
        items: 1,
        loop: !0,
        nav: !0,
        dots: !1,
        autoplay: !0,
        margin: 0,
        navText: ['<div><i class="glyphicon glyphicon-menu-left"></i></div>', '<div><i class="glyphicon glyphicon-menu-right"></i></div>']
    });
    var c = "<ul>";
    if (c += '<li><a href="https://www.facebook.com/sharer/sharer.php?u=' + window.location + '" class="share-link"><i class="fa fa-facebook"></i></a></li>', c += '<li><a href="http://twitter.com/share?url=' + window.location + '" class="share-link"><i class="fa fa-twitter"></i></a></li>', c += "</ul>", $(".product-share-options").append(c), $(".share-link").on("click", function(t) {
            t.preventDefault();
            var o = $(this).attr("href");
            window.open(o, "Share", "width=600,height=400")
        }), $(document).on("click", ".remove-qty", function(t) {
            t.preventDefault();
            let o = $(this).siblings(".qty-input").first(),
                e = o.val();
            e - 1 >= 0 && (o.val(e - 1), o.trigger("change"))
        }), $(document).on("click", ".add-qty", function(t) {
            t.preventDefault();
            let o = $(this).siblings(".qty-input").first(),
                e = parseInt(o.val());
            o.val(e + 1), o.trigger("change")
        }), $(".btn-filter").click(function() {
            $(".collection-sidebar").toggleClass("sidebar-open")
        }), $(document).on("click", ".close-sidebar", function() {
            $(".collection-sidebar").removeClass("sidebar-open")
        }), $("#RecoverPassword").click(function(t) {
            t.preventDefault(), $("#customer-login").hide(), $("#customer-password-reset").show()
        }), $("#CancelRecoverPassword").click(function(t) {
            t.preventDefault(), $("#customer-password-reset").hide(), $("#customer-login").show()
        }), $(".nav-tabs").length) {
        var u = document.location.toString();
        u.match("#") && $('.nav-tabs a[href="#' + u.split("#")[1] + '"]').tab("show")
    }
}), $(function() {
    $(".general-scroll-down span a").on("click", function(t) {
        t.preventDefault(), $("html, body").animate({
            scrollTop: $($(this).attr("href")).offset().top - 150
        }, 500, "linear")
    }), setTimeout(() => {
        $("#scroll-here").show()
    }, 800)
});